import React, { memo } from 'react';

import PlanDetail from './PlanDetail';
import { ConfirmationTypes } from './constants';
import { PlanDetailsProps } from './interfaces';

const PlanDetails = ({
  billingCycle,
  nextBillingAmountWithTax,
  nextBillingDate,
  subscriptionPlan,
  theme,
  confirmationType,
}: PlanDetailsProps): JSX.Element => (
  <dl className="mt-32 text-overline-md">
    <PlanDetail term="Plan" definition={subscriptionPlan} theme={theme} />
    <PlanDetail term="Billing cycle" definition={billingCycle} theme={theme} />
    <PlanDetail term="Next billing date" definition={nextBillingDate} theme={theme} />
    {confirmationType !== ConfirmationTypes.PauseSubscription && (
      <PlanDetail
        term="Next billing amount including tax"
        definition={nextBillingAmountWithTax}
        theme={theme}
      />
    )}
  </dl>
);

export default memo(PlanDetails);
